import { accessDelegationListQueryAtom } from "@/modules/access/delegation/accessDelegationApi.ts";
import { apiTokenListQueryAtom } from "@/modules/access/token/apiTokenApi.ts";
import { mergeQueries } from "@/utils/query/mergeQueries.ts";
import { atom } from "jotai/vanilla";

export const accessListQueryAtom = atom((get) => {
    const apiTokenQ = get(apiTokenListQueryAtom);
    const accessDelegationQ = get(accessDelegationListQueryAtom);
    return mergeQueries({ apiTokenQ, accessDelegationQ }, (maps) => maps.flatMap((m) => [...m.values()]));
});
